import classNames from 'classnames/bind';
import React from 'react';
import { NavigateFunction } from 'react-router-dom';

import Styles from './breadcrumbs.module.scss';

const cx = classNames.bind(Styles);

/*
  Accessibility Notes:
  https://www.w3.org/TR/wai-aria-practices/examples/breadcrumb/index.html

  aria-label - needed for showcasing the type of our navigation element.
  aria-current - Applied to the last link in the set to indicate that it represents the current page.

  ** The seperators need to be added using styles
*/

type BreadcrumbProps = {
  path: string;
  label: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  useNavigate?: NavigateFunction | (() => void) | ((path: string) => void) | null;
};

interface Props {
  crumbs: Array<BreadcrumbProps>;
}

const Breadcrumbs = ({ crumbs }: Props) => {
  if (crumbs.length === 0) {
    return null;
  }

  return (
    <nav aria-label='Breadcrumbs' className={cx('breadcrumbs-nav')}>
      <ol>
        {crumbs.map(({ label, path, useNavigate, ...otherProps }, id) => (
          <li key={path + label}>
            <a
              key={'a' + path + label}
              href={path}
              aria-current={id + 1 === crumbs.length ? 'page' : 'false'}
              onClick={(e) => {
                if (useNavigate) {
                  e.preventDefault();
                  useNavigate(path);
                }
              }}
              {...otherProps}>
              {label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
